import {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { render } from "react-dom";
import { Link, Outlet, Route, useNavigate } from "react-router-dom";
import { AuthContext } from "../../../contexts/AuthContext";

export default function ConfirmPasswordReset() {
  const navigate = useNavigate();
  const { session, supabase } = useContext(AuthContext);
  const [newPassword, setNewPassword] = useState(null);
  const [newPasswordConfirmation, setNewPasswordConfirmation] = useState(null);
  const [canChange, setCanChange] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    supabase.auth.onAuthStateChange(async (event, session) => {
      if (event == "PASSWORD_RECOVERY") {
        setCanChange(true);
      }
    });
  }, []);

  // Load user profile settings into the state
  // Do a deep compare to see if anything is different

  const confirmNewPassword = async () => {
    if (newPassword != newPasswordConfirmation) {
      alert("Password confirmation doesn't match");
      return;
    }
    const { data, error } = await supabase.auth.updateUser({
      password: newPassword,
    });
    if (error) alert("There was an error updating your password.");
    if (data) {
      alert("Password updated successfully!");
      navigate("/");
    }
  };

  if (canChange) {
    return (
      <div className="pt-20">
        <div
          className=" mx-auto gap-8 shadow-xl shadow-gray-100 shadow-opacity-20 rounded-2xl bg-white "
          style={{ maxWidth: 600 }}
        >
          <div className="bg-gray-50 bg-opacity-10 border-b px-8 py-8">
            <img src={"/logo.png"} className="mt-2" style={{ width: 180 }} />
          </div>

          <div className="px-8 py-8">
            <h1 className="text-sm font-semibold text-gray-800 mb-6">
              Reset password for {session.user.email}
            </h1>
            <label className="block text-xs text-gray-700 font-semibold">
              Enter new password
            </label>
            <div className="mt-1 items-center space-y-2">
              <input
                type={"password"}
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                className={`border w-full bg-white shadow-sm border-gray-300 rounded-md text-sm flex-1 text-gray-800`}
              />

              <label className="block text-xs text-gray-700 font-semibold">
                Confirm new password
              </label>
              <input
                type={"password"}
                value={newPasswordConfirmation}
                onChange={(e) => setNewPasswordConfirmation(e.target.value)}
                className={`border bg-white shadow-sm border-gray-300 w-full rounded-md text-sm flex-1 text-gray-800`}
              />
            </div>
            <button
              onClick={() => confirmNewPassword()}
              className="bg-gray-800 mt-6 hover:bg-gray-700 text-white rounded-lg text-xs px-4 py-2.5 border-gray-300 font-medium"
            >
              Confirm new password
            </button>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="pt-20">
        <div
          className=" mx-auto gap-8 shadow-xl shadow-gray-100 shadow-opacity-20 rounded-2xl bg-white "
          style={{ maxWidth: 600 }}
        >
          <div className="bg-gray-50 bg-opacity-10 border-b px-8 py-8">
            <img src={"/logo.png"} className="mt-2" style={{ width: 180 }} />
          </div>

          <div className="p-8">
            <Link to="/">
              <label className="block  cursor-pointer text-xs text-gray-700 font-semibold">
                Invalid password reset session
                <br />
                <u>Return to the app</u>
              </label>
            </Link>
          </div>
        </div>
      </div>
    );
  }
}
